// action types
export const SET_REDIRECT_URL = "setRedirectUrl";

export default {
    namespaced: true,
    state: {
        redirectUrl: "",
    },
    getters: {
        getRedirectUrl(state) {
            return state.redirectUrl;
        },
    },
    actions: {
        [SET_REDIRECT_URL]({ commit }, payload) {
            console.log("setRedirectUrl action called with payload: " + payload);
            commit(SET_REDIRECT_URL, payload);
        },
    },
    mutations: {
        [SET_REDIRECT_URL](state, payload) {
            console.log("SET_REDIRECT_URL mutation called with payload: " + payload);
            state.redirectUrl = payload;
        },
    }
};
